import Button from "../../components/Button";
import { ButtonBackgroundColorType } from "../../components/Button/Button";
import { Close, CloseButton, CloseIcon, Consent, ConsentLink, Container, Description, Headline, ModalBody, ModalContent, Navigation, Spinner, SpinnerImg, SpinnerWrapper, InputContainer, DiscountButton } from "./ContactMeStep.style";
import InputVF from "../../components/InputVF";
import { InputTypeEnum } from "../../components/InputVF/InputVF";
import { AccordionRoutesEnum } from "../../../../types/AccordionRoutes";
import { useEffect, useMemo, useRef, useState } from "react";
import { useStore } from "../../../../store/store";
import { EmailValidationResponse } from "../../../../types/EmailValidationResponse";
import { fetchDiscountStatus, postEmailValidation, postEnrollment } from "../../../../utils/api";
import debounce from "lodash.debounce";
import { VisibleLayoutEnum } from "../../ExternFormEnrollment";
import Analytics from "../../../../utils/analytics";
import { TrackingFlowTypeEnum } from "../../../../types/TrackingFlowTypeEnum";
import { CheckedInput, Input as ProductCardInput } from "../../components/ProductCardV2/ProductCardV2.style";

interface Props {
  showContactMe: boolean;
  onClose: () => void;
}

interface FormData {
  [key: string]: { value: string; error: boolean };
}

export default function ContactMeStep({ showContactMe = false, onClose }: Props) {
  const payload = useStore.usePayload();
  const translations = useStore.useTranslations();
  const setPayload = useStore.useSetPayload();
  const setCompletedAccordionRoute = useStore.useSetCompletedAccordionRoute();
  const setSwitchLayout = useStore.useSetSwitchLayout();
  const [nextAllowed, setNextAllowed] = useState(false);
  const [firstName, setFirstname] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobilePhone, setMobilePhone] = useState("");
  const [isFetching, setIsFetching] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [discountCode, setDiscountCode] = useState("");
  const [showDiscount, setDiscountState] = useState(false);
  const showDiscountField = useStore.useDiscountCodesEnabled();
  const [discountValidated, setdiscountValidated] = useState<boolean>();


  const [emailValidationResponse, setEmailValidationResponse] = useState<EmailValidationResponse>({
    email: "",
    score: 0,
    suggestion: "",
    verdict: "",
  });

  interface FormData {
    [key: string]: { value: string | boolean; error: boolean };
  }  

  const initialFormData = {
    firstName: {
      value: payload.firstName,
      error: !Boolean(payload.firstName),
    },
    lastName: {
      value: payload.lastName,
      error: !Boolean(payload.firstName),
    },
    mobilePhone: {
      value: payload.mobilePhone,
      error: !Boolean(payload.mobilePhone),
    },
    email: {
      value: payload.mailAddress,
      error: !Boolean(payload.mailAddress),
    },
    discountCode: {
      value: payload.discountCode || "",
      error: false,
    },
    consentAccepted: {
      value: false,
      error: true,
    },
  } as FormData;

  const [formData, setFormData] = useState(initialFormData);

  const setValue = (field: string, value: string | boolean, error: boolean) => {
    setFormData({
      ...formData,
      [field]: {
        ...formData[field],
        value,
        error,
      },
    });
  };

  const consentText = translations?.needToContactYouStep.consent

  const discountState = () => {
    setDiscountState(true);
  };
  //Validation for firstname
  const firstnameErrorCheck = (value: string) => {
    const reg = /\d$/;
    if (reg.test(value)) {
      return true
    } else if (!reg.test(value)) {
      return false
    }
  }

  //Validation for firstname and lastname
  const lastnameErrorCheck = (value: string) => {
    const reg = /\d$/;
    if (reg.test(value)) {
      return true
    } else if (!reg.test(value)) {
      return false
    }
  }

  //Validation for mobilePhone
  const mobilePhoneErrorCheck = (value: string) => {
    const reg = /^\+?[0-9]{3}-?[0-9]{5,12}$/;
    if (!reg.test(value)) {
      return true
    } else {
     return false
    }
  }

const validateDiscount = async (discount: string) => {
    if (discount === "") return false;
    const response = (await fetchDiscountStatus(discountCode)).data;
    return response ? true : false;
    
  }

  const validationDiscount = useMemo(() => {
    if(discountCode !== undefined && discountCode !== ""){
      validateDiscount(discountCode).then((v) => {
        setdiscountValidated(v);
      });
    }
  }, [discountCode]);

  //Validation used for styling the input fields  
  const validationFirstname = useMemo(() => {
    if (firstName) {
      if (formData.firstName.error === true) {
        return false;
      } else if (formData.firstName.error === false) {
        return true;
      }
    }
  }, [formData]);

  const validationLastName = useMemo(() => {
    if(lastName) {
      if (formData.lastName.error === true) {
        return false;
      } else if (formData.lastName.error === false) {
        return true; 
      }
    }
  }, [formData]);

  const validationMobilePhone = useMemo(() => {
    if (mobilePhone) {
      if(formData.mobilePhone.error === true) {
        return false;
      } else if (formData.mobilePhone.error === false) {
        return true;
      }
    }
  }, [formData]);
  //Validation used for styling the input fields end


//Email validation
  const emailErrorCheck = () => {
    if (emailValidationResponse.verdict === "Invalid") {
      return false;
    } else if (formData.email.error === false) {
      return true;
    }
  };

  useEffect(() => {
    setValue("email", emailValidationResponse.email, !emailValidationResponse.verdict || emailValidationResponse.verdict === "Invalid" ? true : false);
  }, [emailValidationResponse]);

  const validatingEmailResponse = async (email: string) => {
    if (!email) return;
    try {
      const response = await postEmailValidation(email);
      setEmailValidationResponse(response.data);
    } catch (err) {
      //console.log(err);
    }
  };

  const debouncedEmailValidation = useRef(
    debounce(async (email: string) => {
      await validatingEmailResponse(email);
    }, 300)
  ).current;

  const emailValidation = async (email: string) => {
    debouncedEmailValidation(email);
  };
  //Email validation end


  useEffect(() => {
    const formHasErrors = Object.values(formData)
    .map((v: any) => v.error)
    .includes(true);

    if(!formHasErrors) {
      setNextAllowed(true);
    }
  }, [formData])

  const onSend = async () => {
    setIsFetching(true);
    setShowSpinner(true);
    //Add tracking
    // Analytics.getInstance().trackNeedToContact(payload, TrackingFlowTypeEnum.Vertical, formData.email.value);
    
    const informationData = {
      firstName: formData.firstName.value as string,
      lastName: formData.lastName.value as string,
      mobilePhone: formData.mobilePhone.value as string,
      mailAddress: formData.email.value as string,
      contactMe: true
    };
    setCompletedAccordionRoute(AccordionRoutesEnum.ContactMeStep);
    setPayload(informationData);

    await postEnrollment({
          ...payload,
          ...informationData
        }).then(() => {
          //console.log("Enrollment data sent successfully");
          setShowSpinner(false);
          setIsFetching(false);
          setSwitchLayout(VisibleLayoutEnum.CallMeReciept)
          onClose()
        });
    
    
  }  

  return (
    <Container showContactMe={showContactMe}>
      { showSpinner && 
        <SpinnerWrapper>
          <Spinner>
              <SpinnerImg src="/assets/images/loading.svg" alt="loader" />
          </Spinner>
        </SpinnerWrapper>
      }
      <ModalContent>
        <Close>
          <CloseButton onClick={onClose} >
            <CloseIcon/>
          </CloseButton>
        </Close>
        <ModalBody>
          <Headline>{translations?.needToContactYouStep.title}</Headline>
          <Description>{translations?.needToContactYouStep.description}</Description>
          <Description>{translations?.needToContactYouStep.description2}</Description>
          {/* <Spinner show={true} /> */}
          <InputContainer>
            <InputVF 
              type={InputTypeEnum.text} 
              id="contactMe-firstname" 
              name="contact-firstname" 
              labelText="Fornavn" 
              placeholder="Indtast fornavn her"
              autocomplete="given-name" 
              validated={validationFirstname} 
              step={AccordionRoutesEnum.ContactMeStep}
              errorText={translations?.informationAboutYouStep.errorFirstName}
              onChange={(e) => {
                setFirstname(e.currentTarget.value);
                setValue("firstName", e.currentTarget.value, firstnameErrorCheck(e.currentTarget.value) || !e.currentTarget.value);
              }}
              />
            <InputVF 
              type={InputTypeEnum.text} 
              id="contactMe-lastname" 
              name="contact-lastname" 
              labelText="Efternavn" 
              placeholder="Indtast efternavn her" 
              autocomplete="family-name"
              validated={validationLastName} 
              step={AccordionRoutesEnum.ContactMeStep} 
              errorText={translations?.informationAboutYouStep.errorMissingLastName}
              onChange={(e) => {
                setLastName(e.currentTarget.value);
                setValue("lastName", e.currentTarget.value, lastnameErrorCheck(e.currentTarget.value) || !e.currentTarget.value);
              }}
            />
            <InputVF 
              type={InputTypeEnum.tel} 
              id="contactMe-telephone" 
              name="contact-tel" 
              labelText="Telefon" 
              placeholder="indtast telefonnummer her" 
              autocomplete="tel"
              validated={validationMobilePhone} 
              step={AccordionRoutesEnum.ContactMeStep} 
              errorText={translations?.informationAboutYouStep.errorPhone}
              onChange={(e) => {
                setMobilePhone(e.currentTarget.value);
                setValue("mobilePhone", e.currentTarget.value, mobilePhoneErrorCheck(e.currentTarget.value) || !e.currentTarget.value);
              }}
              />
            <InputVF 
              type={InputTypeEnum.email} 
              id="contactMe-email" 
              name="contact-email" 
              labelText="Email" 
              placeholder="Indtast email her"
              autocomplete="email"
              validated={emailErrorCheck()} 
              step={AccordionRoutesEnum.ContactMeStep}
              onChange={(e) => {
                setValue("email", e.currentTarget.value, true);
                emailValidation(e.currentTarget.value);
              }}
              errorSuggestionText={emailValidationResponse.suggestion} 
              />
              {payload.occupation === "SelfEmployed" && !showDiscount && showDiscountField && (
                <DiscountButton onClick={discountState}>Har du en rabatkode?</DiscountButton>
              )}
              {payload.occupation === "SelfEmployed" && (payload.wantsBasic || payload.wantsHRJura) && showDiscount && showDiscountField && (
                 <InputVF
                                  id="contactMe"
                                  name="contact-discountcode"
                                  type={InputTypeEnum.text}
                                  labelText="Rabatkode"
                                  placeholder="Har du en rabatkode?"
                                  autocomplete="off"
                                  maxlength={20}
                                  onChange={(e) => {
                                    setDiscountCode(e.currentTarget.value);
                                    setPayload({ discountCode: e.currentTarget.value });
                                  }}
                                  validated={discountCode === "" ? undefined : discountValidated}
                                  step={AccordionRoutesEnum.PaymentStep}
                                />
              )}
          </InputContainer>
          {/* Consent checkbox with validation */}
          <Consent>
            <label style={{ display: "flex", alignItems: "flex-start", gap: 8, cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={formData.consentAccepted.value as boolean}
                onChange={e => {
                  setValue("consentAccepted", e.target.checked, !e.target.checked);
                }}
                style={{ position: "absolute", opacity: 0, width: 1, height: 1, pointerEvents: "none" }}
              />
              <ProductCardInput isChecked={formData.consentAccepted.value as boolean}>
                {formData.consentAccepted.value && (<CheckedInput />)}
              </ProductCardInput>
              <span>
                {translations?.needToContactYouStep.consent} {" "}
                <ConsentLink href="https://www.ase.dk/cookie-privatliv-og-persondata" target="_blank">Læs mere her.</ConsentLink>
              </span>
            </label>
            {formData.consentAccepted.error && (
              <div style={{ color: "#D43F3A", fontSize: 13, marginTop: 4 }}>
                Du skal acceptere samtykke for at fortsætte.
              </div>
            )}
          </Consent>
          <Navigation>
            <Button bgColor={ButtonBackgroundColorType.Transparent} blockButton={false} onClick={onClose}>Tilbage</Button>
            <Button bgColor={nextAllowed && !isFetching ? ButtonBackgroundColorType.Orange : ButtonBackgroundColorType.Grey} disabled={(nextAllowed ? false : true) || isFetching} blockButton={false} onClick={onSend}>
              Send
            </Button>
          </Navigation>
        </ModalBody>
      </ModalContent>
    </Container>
  );
}
